import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PageHeroProps {
  image: string;
  title: string;
  subtitle?: string;
  badge?: string;
  ctaText?: string;
  ctaLink?: string;
  height?: string;
  /** Optional descriptive alt text. Falls back to title when omitted. */
  imageAlt?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ image, title, subtitle, badge, ctaText, ctaLink, height = 'h-[70vh]', imageAlt }) => {
  const navigate = useNavigate();

  return (
    <section className={`relative ${height} w-full overflow-hidden`}>
      <img
        src={image}
        alt={imageAlt || `${title.replace(/\n/g, ' ')} - Zera Travel luxury Albania`}

        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        fetchPriority="high"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 lg:pb-24 px-6 lg:px-12 max-w-[1440px] mx-auto">
        {badge && (
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">{badge}</span>
          </div>
        )}
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-white leading-[1.1] mb-4 max-w-3xl whitespace-pre-line">
          {title}
        </h1>
        {subtitle && (
          <p className="font-sans text-sm md:text-base font-light text-white/70 max-w-xl leading-relaxed mb-8">
            {subtitle}
          </p>
        )}
        {ctaText && ctaLink && (
          <button
            onClick={() => navigate(ctaLink)}
            className="self-start font-sans text-[11px] tracking-[0.25em] uppercase px-10 py-4 bg-[#C9A961] text-white hover:bg-[#b8944d] transition-all duration-300"
          >
            {ctaText}
          </button>
        )}
      </div>
    </section>
  );
};

export default PageHero;
